import React from "react";
import MickeyEars from "./MickeyEars";

export const Footer = () => {
    return (
        <footer
            data-testid="site-footer"
            className="bg-accent text-accent-foreground border-t-4 border-black"
        >
            <div className="max-w-6xl mx-auto px-6 py-12 flex flex-col sm:flex-row items-center justify-between gap-6">
                <div className="flex items-center gap-4">
                    <MickeyEars size={42} color="#fff" />
                    <div>
                        <p className="font-heading text-xl font-bold leading-none">
                            Festa do Mickey
                        </p>
                        <p className="font-heading text-sm uppercase tracking-widest opacity-70 mt-1">
                            Christopher • 12 de Julho
                        </p>
                    </div>
                </div>
                <p className="text-sm opacity-70 text-center sm:text-right">
                    Feito com carinho para o aniversariante mais especial 💛
                </p>
            </div>
        </footer>
    );
};

export default Footer;
